import { render, staticRenderFns } from "./area.vue?vue&type=template&id=074867ed&scoped=true"
import script from "./area.vue?vue&type=script&lang=js"
export * from "./area.vue?vue&type=script&lang=js"
import style0 from "./area.vue?vue&type=style&index=0&id=074867ed&prod&lang=less"
import style1 from "./area.vue?vue&type=style&index=1&id=074867ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074867ed",
  null
  
)

export default component.exports